import { createApp } from "vue";
import App from "./App.vue";

/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import i18n from "@/core/plugins/i18n";
//imports for app initialization
// import MockAdapter from "@/core/mock/MockService";
import ApiService from "@/core/services/ApiService";
import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
// import { initVeeValidate } from "@/core/plugins/vee-validate";
// import Datepicker from "@vuepic/vue-datepicker";
// import "@vuepic/vue-datepicker/dist/main.css";
import "@/core/plugins/keenthemes";
import "@/core/plugins/prismjs";
import "bootstrap";
import { initVeeValidate } from "./core/plugins/vee-validate";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
const app = createApp(App);
app.config.errorHandler = (err) => {
  // eslint-disable-next-line no-console
  console.error(err);
  Swal.fire({
    title: "เกิดข้อผิดพลาด",
    text: "ระบบพบข้อผิดพลาดที่ไม่คาดคิด กรุณาโหลดหน้าใหม่อีกครั้ง",
    icon: "error",
    confirmButtonColor: "#323563",
    confirmButtonText: "โหลดหน้าใหม่",
    allowOutsideClick: false,
    showCancelButton: false,
  }).then(() => {
    router.push("/sign-in").then(() => {
      window.location.reload();
    });
  });
};
app.config.warnHandler = () => null;
// adminDream
app.use(store);
app.use(router);
app.use(ElementPlus);
ApiService.init(app);
initApexCharts(app);
initInlineSvg(app);
initVeeValidate();

app.use(i18n);

app.mount("#app");
